/* eslint-disable */
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { withRouter, Redirect } from 'react-router-dom';

import Immutable from 'immutable';

import { isEqual, isEmpty } from 'lodash-es';

import { SortDirection } from 'react-virtualized';

import { CircularProgress, Button } from 'react-md';

import { CoogTable } from '@coog/react-components';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../Theme/theme';

import * as contractsActions from '../../Services/Contracts/actions';
import * as productsActions from '../../Services/Products/actions';

import { columns, filtersUI } from './config';
import { applyFilters } from './filters';

import { stringifyQuery, parseQuery } from '../../Utils/Utils';
import FilterControls from '../../Components/Filter/FilterControls';

import './Contracts.scss';

class Contracts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectTo: undefined,
      list: undefined,
      filteredList: undefined,
      filters: props.filters,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromProps(nextProps, prevState) {
    const { list: nextList } = nextProps;
    const { list: prevList } = prevState;
    let newState = null;

    if (nextList && !!nextList.toJS && !Immutable.is(prevList, nextList)) {
      newState = {
        list: nextList, // TODO add filtering statement...
      };
    }

    return newState;
  }

  componentDidMount() {
    const self = this;
    const { actions, list, location, history, filters: defaultFilters, system } = self.props;

    actions.fetchContractsV2();
    actions.fetchCommercialProductsV2()
    // Filters

    const filters = isEmpty(parseQuery(location.search)) ? defaultFilters : parseQuery(location.search);

    if (!filters.status) {
      filters.status = [];
    }
    if (filters?.status.length === 0) {
      filters.status.push('quote').push('active');
    }

    self.setState({ filters });
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    if (list) {
      self.filter({ list, ref: 'componentDidMount', filters });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;
    const { filters: prevFilters } = prevState;
    const { list, location } = self.props;
    //
    if (!Immutable.is(prevProps.list, list)) {
      if (typeof list !== 'undefined' && !Immutable.is(prevState.list !== list)) {
        self.filter({ list, ref: 'componentDidUpdate1' });
      }
    }
    // Filters
    const filters = prevFilters || parseQuery(location.search);
    if (typeof list !== 'undefined' && filters && !isEqual(prevFilters, filters)) {
      self.setState({ filters });
      self.filter({ list, ref: 'componentDidUpdate2' });
    }
  }

  handleFiltersChange = filters => {
    const { list, history, location } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    this.setState({ filters });
    this.filter({ list, ref: 'handleFiltersChange', filters });
  };

  handleLoadMore = () => {
    const self = this;
    const { actions, currentOffset } = self.props;
    const offset = currentOffset || 0;
    actions.loadMoreContracts({ offset })
  }

  filter = ({ list, /* ref, */ filters: newFilters }) => {
    const { filters } = this.state;
    const filteredList = applyFilters({ list, filters: newFilters || filters });
    // eslint-disable-next-line react/no-did-update-set-state
    this.setState({ filteredList });
  };

  // eslint-disable-next-line no-unused-vars
  handleGetRoute = ({ route, action, type, id }) => {
    this.setState({
      redirect: true,
      redirectTo: `${route}${id}`,
    });
  };

  handleAction = ({ route, action, type, id }) => {
    const { actions } = this.props;
    if (type === 'action') {
      switch (action) {
        case 'cancel':
          actions.cancelQuotation({ payload: { id } });
          break;
        default:
          break;
      }
    } else {
      this.handleGetRoute({ route, action, type, id });
    }
  };

  render() {
    const { redirect, redirectTo, list, filteredList, filters } = this.state;
    const { system } = this.props;
    if (redirect) return <Redirect push to={redirectTo} />;

    const { pageTitle, canonical, strings, contractStatus, commercialproducts } = this.props;
    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || 'Contrats'}</title>
        <meta name="description" content={strings[pageTitle] || 'Contrats'} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );
    const contracts = () =>
      list && filteredList ? (
        <MuiThemeProvider theme={theme}>
          <CoogTable
            defaultSorted={{ sortBy: 'createdDate', sortDirection: SortDirection.DESC }}
            rows={filteredList}
            columns={columns(this.handleAction, strings, system.i18n)}
            strings={strings}
            uid="id"
            onClickCellAction={this.handleAction}
            contractStatus={contractStatus}
          />
        </MuiThemeProvider>
      ) : (
        <CircularProgress id="quotations-loading" className="loading" scale={3} style={{ margin: '2em auto' }} />
      );

    return (
      <div className="coog-app contracts">
        {helmet}
        <div className="blocks-header">
          <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || 'Contrats'}</h1>
        </div>
        <div className="block-controls">
          {filteredList ? (
            <div className="block-info">
              <span className="value">{filteredList.size}</span>
              <span className="label">{strings['contracts.controls.info.label'] || 'Contrat(s) trouvé(s)'}</span>
            </div>
          ) : (
            undefined
          )}
          <Button
            flat
            primary
            iconChildren="loop"
            iconBefore={true}
            // tooltipLabel={strings['parties.actions.load_more.btn.label'] || 'Charger plus'}
            // tooltipPosition="right"
            onClick={() => this.handleLoadMore()}
            id="load-more"
          >
            {strings['parties.actions.load_more.btn.label'] || 'Rafraîchir la liste'}
          </Button>
          <FilterControls
            id="contracts-filters-block"
            key="contracts-filters-block"
            strings={strings}
            filters={filters}
            onFiltersChange={this.handleFiltersChange}
            filtersUI={filtersUI({ strings, contractStatus, commercialproducts })}
          />
        </div>
        <div className="md-body md-cell md-cell--12">{contracts()}</div>
      </div>
    );
  }
}

Contracts.propTypes = {
  actions: PropTypes.shape({
    getRoute: PropTypes.func,
    fetchContracts: PropTypes.func,
    fetchContractStatus: PropTypes.func,
    fetchCommercialProducts: PropTypes.func,
  }),
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  list: PropTypes.instanceOf(Immutable.List),
  // eslint-disable-next-line
  match: PropTypes.object.isRequired,
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  // eslint-disable-next-line
  filters: PropTypes.object,
  // eslint-disable-next-line
  contractStatus: PropTypes.object,
  // eslint-disable-next-line
  system: PropTypes.object,
  // eslint-disable-next-line
  commercialproducts: PropTypes.array,
};

Contracts.defaultProps = {
  actions: {
    getRoute: () => { },
  },
  pageTitle: 'title.contracts.list',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  list: undefined,
  filters: {
    query: '',
    status: [],
    commercialProductId: [],
  },
  contractStatus: undefined,
  commercialproducts: undefined,
  system: undefined,
};

// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
  system: state.toJS().system,
  strings: state.toJS().contracts.strings,
  list: state.getIn(['contracts', 'list']),
  filters: state.getIn(['contracts', 'filters']).toJS(),
  contractStatus: state.getIn(['contracts']).toJS().contractStatus,
  commercialproducts: state.toJS().products.commercialproductsV2,
  currentOffset: state.getIn(['contracts', 'currentOffset']),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...contractsActions, ...productsActions }, dispatch),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Contracts)
);
